// extracted by mini-css-extract-plugin
module.exports = {"Container":"FailureScreen_Container__1JQOg","Options":"FailureScreen_Options__1yFEC"};